import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

interface Props {
  onSearch: (kw: string) => void;
}

export default function Hero({ onSearch }: Props) {
  const [kw, setKw] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(kw.trim());
  };

  return (
    <section className="relative overflow-hidden bg-background-100">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20cinematic%20anime%20landscape%20of%20a%20hidden%20ninja%20village%20at%20golden%20sunset%20with%20warm%20orange%20sky%2C%20stylized%20swirling%20clouds%20and%20distant%20mountains%2C%20cozy%20warm%20amber%20and%20red%20color%20palette%2C%20painterly%20stylized%20illustration%20not%20photorealistic%2C%20atmospheric%2C%20high%20detail&width=1600&height=900&seq=hero-naruto-fan&orientation=landscape"
          alt="火影同人动漫 - 忍界同人作品聚合首页背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-100" />
      </div>

      <div className="container-x relative flex w-full flex-col items-center py-20 text-center md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-accent-500" />
          穿越 · 系统 · 重生 · 日常 · 战斗 全收录
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          想看哪类火影同人，
          <br className="hidden md:block" />
          直接点，快速找到对味的
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          汇集穿越、系统、重生、日常、战斗等各类火影同人作品，按剧情类型整理分类。
          无论你偏爱热血对决还是温馨日常，都能在这里精准找到，追更不迷路。
        </p>

        <form
          onSubmit={submit}
          className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center"
          role="search"
        >
          <label className="sr-only" htmlFor="hero-search">
            搜索火影同人作品
          </label>
          <input
            id="hero-search"
            type="search"
            value={kw}
            onChange={(e) => setKw(e.target.value)}
            placeholder="输入关键词，如：穿越、系统、木叶…"
            className="flex-1 rounded-md border border-background-50/30 bg-background-50/95 px-4 py-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-300"
          />
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line" />
            搜索
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="inline-flex items-center gap-1.5 rounded-full border border-background-50/30 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium whitespace-nowrap text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <i className={`${c.icon} text-accent-500`} />
              {c.name}
            </Link>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-xs text-background-100">
          <span className="flex items-center gap-1.5">
            <i className="ri-book-open-line text-accent-500" /> 16+ 精选同人作品
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-refresh-line text-accent-500" /> 每日更新整理
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-folder-open-line text-accent-500" /> 5 大剧情分类
          </span>
        </div>
      </div>
    </section>
  );
}